<!-- MOLECULE: FooterCopyright.vue -->

<script setup lang="ts">
//
// ============================================================================
// PROPS
// ============================================================================
//

interface Props {
  copyrightPrefix: string;
  companyName: string;
  companyUrl?: string;
  companyTooltip?: string;
  productName: string;
  productUrl?: string;
  productTooltip?: string;
  versionLabel: string;
}

defineProps<Props>();

//
// ============================================================================
// COMPOSABLES
// ============================================================================
//

const config = useRuntimeConfig();

//
// ============================================================================
// COMPUTED PROPERTIES
// ============================================================================
//

const currentYear = computed(() => new Date().getFullYear());

const appVersion = computed(() => config.public.VER || "1.0.0");
</script>

<template>
  <p class="mb-0 text-body-2 text-center">
    <!-- Prefix & Year -->
    {{ copyrightPrefix }} {{ currentYear }}

    <!-- Separator -->
    <span class="ml-1 mr-2">-</span>

    <!-- Company -->
    <v-hover v-if="companyUrl" v-slot="{ isHovering, props: hoverProps }">
      <a
        v-tooltip:top="{ text: companyTooltip, openDelay: 500, closeDelay: 200 }"
        v-bind="hoverProps"
        :href="companyUrl"
        target="_blank"
        rel="noopener"
        class="text-primary text-decoration-none font-weight-medium"
        :class="[isHovering ? 'opacity-80 text-decoration-underline' : 'opacity-100']"
        :text="companyName"
      />
    </v-hover>
    <span v-else>{{ companyName }}</span>

    <!-- Separator -->
    <span class="mx-1">|</span>

    <!-- Product -->
    <v-hover v-if="productUrl" v-slot="{ isHovering, props: hoverProps }">
      <a
        v-tooltip:top="{ text: productTooltip, openDelay: 500, closeDelay: 200 }"
        v-bind="hoverProps"
        :href="productUrl"
        target="_blank"
        rel="noopener"
        class="text-primary text-decoration-none font-weight-medium"
        :class="[isHovering ? 'opacity-80 text-decoration-underline' : 'opacity-100']"
        :text="productName"
      />
    </v-hover>
    <span v-else>{{ productName }}</span>

    <!-- Separator -->
    <span class="mx-1">|</span>

    <!-- Version -->
    {{ versionLabel }} {{ appVersion }}
  </p>
</template>
